import {alpha, useTheme} from '@mui/material';
import {Button, Stack, Typography} from '@mui/material';
import {FontIcon} from 'components';
import {useTranslate} from 'hooks';

export const LoginMBIDError = () => {
  const theme = useTheme();
  const translate = useTranslate();

  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{height: '100vh', textAlign: 'center'}}>
      <FontIcon
        style={{height: 64}}
        icon={['far', 'cloud-exclamation']}
        color={alpha(theme.palette.grey[900], 0.5)}
      />

      <Typography variant="h2">
        {translate('common.login.error.title')}
      </Typography>

      <Stack spacing={0.5}>
        <Typography
          variant="body1"
          color={theme.palette.text.secondary}
          sx={{maxWidth: 400, textAlign: 'center'}}>
          {translate('common.login.error.subtitle')}
        </Typography>
      </Stack>

      <Button
        href="/"
        variant="contained"
        color="secondary"
        sx={{
          width: 400,
          height: 48,
          borderRadius: 60,
        }}>
        <Typography variant="button">
          {translate('common.back-to-login')}
        </Typography>
      </Button>
    </Stack>
  );
};
